package one.healthium.update_food_preferences.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultUpdateFoodPreferencesComponent(
    componentContext: ComponentContext,
    private val onCloseClicked: () -> Unit,
) : UpdateFoodPreferencesComponent, ComponentContext by componentContext,
    ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }
}